import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter  }  from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { languageService, languageSupport } from '@app/modules/common/language';
import { PeriodData } from '@app/modules/model/period';

/************************************/
/* USER COMPONENT                   */
/************************************/

@Component({
    selector: 'ui-period',
    templateUrl: 'ui-period.html',
    styleUrls: [
      'ui-period.scss'
    ]
})
export class UiPeriod extends languageSupport implements OnInit, OnChanges, OnDestroy {    
    @Input('readonly') _readonly = true;
    @Input('period') _period: PeriodData = null;
    
    constructor(lang: languageService) {
        super(lang, null)
    }

    private periodTimeValidator(control: FormControl) : any {
        let _value = control.value;
        let _regexp_hhmm = new RegExp(/^([0-9]|([01]\d|2[0-3])):([0-5]\d)$/);

        if (!_regexp_hhmm.test(_value ? _value.trim() : '')) {
            return { 'format': true }; 
        }
        return null;
    }

    private periodDaysValidator(control: FormControl) : any {
        return (control.value == "0000000") ? { 'nodays': true} : null;
    }

    private validatePeriod(group: FormGroup):any {
        let _ini = group.get('ini');
        let _end = group.get('end');
        
        if (_ini.valid && _end.valid){
            let _part_ini = _ini.value.split(':'); 
            let _part_end = _end.value.split(':'); 

            let _date_ini = new Date(2000, 0, 1, parseInt(_part_ini[0]), parseInt(_part_ini[1]));
            let _date_end = new Date(2000, 0, 1, parseInt(_part_end[0]), parseInt(_part_end[1]));

            if (_date_ini >= _date_end){
                _end.setErrors({ 'pastdate': true });
            }
        }

        return null;
    }

    private _hhmm(info) {
        if (info){
            let _parts = info.split(':');
        
            let _hh = ("0" + parseInt(_parts[0])).slice(-2);
            let _mm = ("0" + parseInt(_parts[1])).slice(-2);
    
            return _hh + ":" + _mm;    
        }
        return null;
    }

    private _periodForm = null;
    get PeriodForm(){
        if (!this._periodForm){
            let _ini = this._hhmm(this._period ? this._period.ini : null);
            let _end = this._hhmm(this._period ? this._period.end : null);
            let _weekdays = this._period ? this._period.weekdays : "0000000";
            let _tz = this._period ? this._period.timezone : new Date().getTimezoneOffset();
            
            this._periodForm = new FormGroup({
                ini: new FormControl(_ini, [
                    Validators.required,
                    this.periodTimeValidator.bind(this)
                ]),
                end: new FormControl(_end, [
                    Validators.required,
                    this.periodTimeValidator.bind(this)
                ]),
                weekdays: new FormControl(_weekdays, [
                    this.periodDaysValidator.bind(this)
                ]),
                tz: new FormControl(_tz, [
                    // no validators required 
                ]),
            }, this.validatePeriod);
        }
        
        return this._periodForm;
    }

    ngOnInit() {
        // nothing to do
    }

    ngOnDestroy() {
        super.OnDestroy();
    }

    ngOnChanges(changes) {
        this.onChange();
    }
    
    @Output('onChange') _onChange = new EventEmitter<any>();     
    private onChange() {
        if (!this.PeriodForm.dirty){
            return;
        }

        if (this.PeriodForm.valid) {
            this._period.ini = this._periodForm.get('ini').value;
            this._period.end = this._periodForm.get('end').value;
            this._period.weekdays = this._periodForm.get('weekdays').value;
            this._period.timezone = this._periodForm.get('tz').value;
        }

        this._onChange.emit(this.PeriodForm.valid);
    }

    public _weekidx = [ 0, 1, 2, 3, 4, 5, 6 ];

    GetActiveDay(day){
        return (this._periodForm.get('weekdays').value[day] == '1');
    }

    SetActiveDay(day){
        let _weekdays = this._periodForm.get('weekdays').value;
        _weekdays = _weekdays.substr(0, day) + ((_weekdays[day] == '1') ? "0" : "1") + _weekdays.substr(day + 1);
        this._periodForm.get('weekdays').setValue(_weekdays);
        this._periodForm.get('weekdays').markAsDirty();
        
        this.onChange();
    }
    
    OnTimeChange(control){
        let _value = control.value;
        if (_value){
            control.setValue(_value.trim());
        }
        
        this.onChange();
    }
}